import { mapWeatherKeyToIconName } from "helpers/weatherIconsKeyMapper";
import useDynamicSVGImport from "hooks/useDynamicSVGImport";

interface IWeatherCustomIconProps {
  id: string;
  weatherIconId: string;
  onCompleted?: (
    name: string,
    SvgIcon: React.FC<React.SVGProps<SVGSVGElement>> | undefined
  ) => void;
  onError?: (err: Error) => void;
}

const WeatherCustomIcon = (props: IWeatherCustomIconProps): any => {
  const assetPath : string = "assets/weatherIcons";
  const {
    id, weatherIconId, onCompleted, onError
  } = props;
  const wasteTypeIconName = mapWeatherKeyToIconName(weatherIconId);
  const { error, loading, SvgIcon } = useDynamicSVGImport(wasteTypeIconName, assetPath, {
    onCompleted,
    onError
  });
  if (error) {
    return error.message;
  }
  if (loading) {
    return "Loading...";
  }
  if (SvgIcon) {
    return (
      <SvgIcon data-testid={`${id}-${weatherIconId}-${wasteTypeIconName}`} />
    );
  }
  return null;
};

export default WeatherCustomIcon;
